var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.386,
    height: 43.386,
    viewBox: "0 0 43.386 43.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.c46ab731ef73dd65fb3d486524570e7c6{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H43.386V43.386H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c46ab731ef73dd65fb3d486524570e7c6",
    d: "M33.29,21.849a14.087,14.087,0,0,0,.127-1.772,14.088,14.088,0,0,0-.127-1.772L37.1,15.323a.912.912,0,0,0,.217-1.157L33.706,7.911a.909.909,0,0,0-1.1-.4L28.1,9.321A13.208,13.208,0,0,0,25.047,7.55L24.36,2.759A.881.881,0,0,0,23.474,2H16.243a.881.881,0,0,0-.886.759L14.671,7.55a13.889,13.889,0,0,0-3.055,1.772l-4.5-1.808a.882.882,0,0,0-1.1.4L2.4,14.166a.891.891,0,0,0,.217,1.157l3.814,2.983A14.336,14.336,0,0,0,6.3,20.077a14.336,14.336,0,0,0,.127,1.772L2.613,24.832A.912.912,0,0,0,2.4,25.989l3.615,6.255a.909.909,0,0,0,1.1.4l4.5-1.808a13.208,13.208,0,0,0,3.055,1.772l.687,4.791a.881.881,0,0,0,.886.759h7.231a.881.881,0,0,0,.886-.759l.687-4.791A13.889,13.889,0,0,0,28.1,30.833l4.5,1.808a.882.882,0,0,0,1.1-.4l3.615-6.255a.912.912,0,0,0-.217-1.157ZM19.859,26.4a6.327,6.327,0,1,1,6.327-6.327A6.334,6.334,0,0,1,19.859,26.4Z",
    transform: "translate(1.834 1.615)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b31b00e0.svg";
export { ForwardRef as ReactComponent };